import React from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import { base_url } from "Backend/api";
import { resolveMarketHomeCardOrdersCount } from "../../../utils/storeOrdersCount";

function resolveImage(market) {
  const raw = market?.image_url;
  if (raw && /^https?:\/\//i.test(String(raw))) return String(raw);
  if (raw) {
    const path = String(raw).replace(/^\/+/, "");
    return `${String(base_url).replace(/\/$/, "")}/${path}`;
  }
  if (market?.image) {
    return `${String(base_url).replace(/\/$/, "")}/storage/app/public/${String(
      market.image
    ).replace(/^\/+/, "")}`;
  }
  return "/assets/images/logo.jpeg";
}

function marketCategoryLabel(market) {
  if (Array.isArray(market?.store_categories) && market.store_categories.length) {
    const sorted = [...market.store_categories].sort(
      (a, b) => (a?.display_order ?? 0) - (b?.display_order ?? 0)
    );
    return sorted.map((c) => c?.name).filter(Boolean).join("، ");
  }
  const t = market?.type ?? market?.category ?? "";
  return String(t).replace(/\s*,\s*/g, "، ").trim();
}

const MarketHomeCard = ({ market, isFavorite, onCardClick, onFavoriteClick }) => {
  const isActive =
    market?.is_open_now === true ||
    market?.status === "open" ||
    market?.status === "active" ||
    market?.status_code === "active";
  const category = marketCategoryLabel(market);
  const rating = market?.rating?.average ?? "—";
  const reviews = market?.rating?.reviews_count ?? market?.rating?.total_count ?? 0;
  const orderCount = resolveMarketHomeCardOrdersCount(market);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => market?.slug && onCardClick?.(market.slug)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          market?.slug && onCardClick?.(market.slug);
        }
      }}
      className="cursor-pointer rounded-[8px] border border-gray-200 bg-white shadow-sm outline-none transition duration-300 group overflow-hidden font-[cairo]"
      dir="rtl"
    >
      <div className="relative h-[100px] w-full overflow-hidden sm:h-[168px]">
        <Image
          src={resolveImage(market)}
          alt={market?.name ?? ""}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
        />

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            market?.slug && onFavoriteClick?.(market.slug);
          }}
          className="absolute end-2 top-2 z-20 flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md transition hover:bg-gray-50"
          aria-label="المفضلة"
        >
          <Icon
            name="Heart"
            size={16}
            color={isFavorite ? "#00B200" : "#9ca3af"}
            fill={isFavorite ? "#00B200" : "none"}
          />
        </button>

        {!!market?.offers?.length && (
          <div className="absolute end-2 top-2 z-10 flex max-w-[55%] flex-col items-end gap-1 pt-1">
            {market.offers.slice(0, 2).map((offer, index) => (
              <span
                key={offer?.id ?? index}
                className="flex max-w-full items-center gap-1 rounded-s-lg bg-[#F93209] py-1 pe-2 ps-2 text-[9px] font-bold leading-tight text-white shadow"
              >
                <span className="line-clamp-2 break-words text-end">{offer?.title}</span>
                <img src="/assets/images/badd.svg" className="h-3.5 w-3.5 shrink-0 opacity-95" alt="" />
              </span>
            ))}
          </div>
        )}

        <div className="absolute bottom-[-2px] start-[-8px] z-10 flex items-center gap-1 rounded-full bg-[#3AD900] px-2 py-0.5 shadow-sm">
          <Icon name="Star" size={12} color="#FF9F06" fill="#FF9F06" className="shrink-0 mr-1" />
          <span className="text-[10px] font-bold text-white">
            {rating}
            <span className="font-medium opacity-95"> ({reviews})</span>
          </span>
        </div>
      </div>

      <div className="space-y-2 p-3 sm:p-3.5">
        <h3 className="line-clamp-1 text-right text-[13px] font-bold font-[cairo] text-gray-900 sm:text-base">
          {market?.name}
        </h3>

        <div className="flex items-start justify-between gap-2 text-[11px] sm:text-xs">
          <span className="shrink-0 text-right font-medium text-gray-800">
            يبدأ من {market?.minimum_order ?? "—"} ل.س
          </span>
          <span className="line-clamp-1 min-w-0 flex-1 text-left text-gray-600">{category || "\u00A0"}</span>
        </div>

        <div dir="rtl" className="flex flex-row items-center justify-between gap-2 text-[10px] sm:text-[11px]">
          <span className={`flex shrink-0 items-center gap-1.5 font-medium ${isActive ? "text-[#00B200]" : "text-red-500"}`}>
            <span className={`h-2 w-2 rounded-full ${isActive ? "bg-[#00B200]" : "bg-red-500"}`} />
            {market?.status_label || (isActive ? "نشط" : "غير نشط")}
          </span>
          <span className="flex min-w-0 items-center gap-1.5 text-gray-600">
            <img src="/assets/images/bbagg.svg" className="h-3 w-3" alt="bag" />
            <span className="truncate">
              {orderCount != null ? String(orderCount) : "—"} طلب
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default MarketHomeCard;
